import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { AnnualDeclarationFormService } from '../shared/service/annual-declaration-form.service';

export interface FormData {
  societeId: string;
  formYear: number;
}

@Component({
    selector: 'odq-non-voting-parts-summary-dialog',
    templateUrl: './non-voting-parts-summary-dialog.component.html',
    styleUrls: ['./non-voting-parts-summary-dialog.component.scss'],
    standalone: false
})
export class NonVotingPartsSummaryDialogComponent implements OnDestroy, OnInit {

  destroy$ = new Subject<void>();
  hasTrusteesErrors = !this.annualDeclarationFormService.isNonVotingTrusteesCountValid();
  hasNonVotingPartsCountErrors = !this.annualDeclarationFormService.isNonVotingPartsTotalsValid();

  myGroup: UntypedFormGroup;

  constructor(
    private annualDeclarationFormService: AnnualDeclarationFormService,
    public dialogRef: MatDialogRef<NonVotingPartsSummaryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public formData: FormData,
  ) { }

  ngOnInit() {
    const memberTotal = this.annualDeclarationFormService.getMembersNonVotingPartsTotal();
    const legalPersonTotal = this.annualDeclarationFormService.getLegalPersonsNonVotingPartsTotal();
    const allNonVotingTotal = this.annualDeclarationFormService.getNonVotingPartsTotal();

    this.myGroup = new UntypedFormGroup({
      numberNonVotingODQ: new UntypedFormControl(memberTotal),
      numberNonVotingOther: new UntypedFormControl(legalPersonTotal),
      numberNonVotingTotal: new UntypedFormControl(allNonVotingTotal),
    });

    this.myGroup.disable();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fixErrors() {
    if (this.hasTrusteesErrors) {
      this.dialogRef.close('nbTrustees');
    } else {
      this.dialogRef.close();
    }
  }

  nextStep() {
    this.dialogRef.close('nextStep');
  }
}
